import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {LoginPageComponent} from './pages/login/login-page.component';
import {LayoutComponent} from './pages/layout/layout.component';
import {AuthGuard} from './@core/auth.guard';
import {RedirectComponent} from './pages/redirect.component';
import {ForwardComponent} from './pages/forward.component';

const routes: Routes = [
  {
    path: '', component: LayoutComponent, canActivate: [AuthGuard], canActivateChild: [AuthGuard], children: [
      {path: '', redirectTo: 'welcome', pathMatch: 'full'},
      {path: 'welcome', loadChildren: () => import('./modules/welcome/welcome.module').then(m => m.WelcomeModule)},
      {path: 'hypar', loadChildren: () => import('./modules/hypar/hypar.module').then(m => m.HyparModule)},
      {path: 'facility', loadChildren: () => import('./modules/facility/facility.module').then(m => m.FacilityModule)},
      {path: 'management', loadChildren: () => import('./modules/management/management.module').then(m => m.ManagementModule)},
      {path: 'resident', loadChildren: () => import('./modules/covid/covid.module').then(m => m.CovidModule)},
      {path: 'admission', loadChildren: () => import('./modules/admission/admission.module').then(m => m.AdmissionModule)},
      {path: 'internal', loadChildren: () => import('./modules/internal/internal.module').then(m => m.InternalModule)},
      {path: 'ethas', loadChildren: () => import('./modules/ethas/ethas.module').then(m => m.EthasModule)},
      {path: 'discipline', loadChildren: () => import('./modules/discipline/discipline.module').then(m => m.DisciplineModule)},
    ]
  },
  {path: 'login', component: LoginPageComponent},
  {path: 'redirect/:token', component: RedirectComponent},
  {path: 'login/:token', component: LoginPageComponent},
  {path: 'forward', component: ForwardComponent},
  {path: '**', redirectTo: 'login'}
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {})],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
